// extracted by mini-css-extract-plugin
module.exports = {"settimana":"SettimanaGravidanza_settimana__OpXqI","settimana--selected":"SettimanaGravidanza_settimana--selected___RBWw","rotation":"SettimanaGravidanza_rotation__Fqvi_"};